export type {
  /**
   * @deprecated - this bundle should be a shared layer
   */
  UppyFile,
  /**
   * @deprecated - this bundle should be a shared layer
   */
  UppyProgress,
  /**
   * @deprecated - this bundle should be a shared layer
   */
  UppyResponse,
  /**
   * @deprecated - this bundle should be a shared layer
   */
  UppyUploadEventData,
  /**
   * @deprecated - this bundle should be a shared layer
   */
  UppyCompleteEventResult,
  /**
   * @deprecated - this bundle should be a shared layer
   */
  UppyError,
  /**
   * @deprecated - this bundle should be a shared layer
   */
  UppyEventMap,
  /**
   * @deprecated - this bundle should be a shared layer
   */
  UppyS3UploadParams,
  /**
   * @deprecated - this bundle should be a shared layer
   */
  TMeta,
  /**
   * @deprecated - this bundle should be a shared layer
   */
  TBody,
} from 'bundles/fileuploader-uppy/types/UppyFileUploader';

export {
  /**
   * @deprecated - this bundle should be a shared layer
   */
  default as UppyFileUploader,
} from 'bundles/fileuploader-uppy/components/UppyFileUploader';
